

export const FETCH_AUTH_TOKEN_REQUEST = 'FETCH_AUTH_TOKEN_REQUEST';
export const FETCH_AUTH_TOKEN_SUCCESS = 'FETCH_AUTH_TOKEN_SUCCESS';
export const FETCH_AUTH_TOKEN_FAILURE = 'FETCH_AUTH_TOKEN_FAILURE';
export const START_AUTH_HEART_BEAT = 'START_AUTH_HEART_BEAT';
export const STOP_AUTH_HEART_BEAT = 'STOP_AUTH_HEART_BEAT';